import { FC } from 'react';

import NoResults from '@/assets/icons/NoResults';
import { Button } from '@/components/UI/Button/Button';

type PlankNothingToShowProps = {
  openIndelenPanel: () => void;
};
const PlankNothingToShow: FC<PlankNothingToShowProps> = ({ openIndelenPanel }) => {
  return (
    <div
      style={{
        backgroundColor: 'var(--tractie-color-background-elevated-sunken)',
        color: 'var(--tractie-color-content-default)',
        display: 'flex',
        justifyContent: 'center',
        paddingTop: '250px',
        alignItems: 'center',
        width: '100vw',
        flexDirection: 'column',
      }}
    >
      <NoResults data-icon='NoResults' height='150px' width='150px' />
      <div style={{ fontSize: '20px', marginTop: '35px' }}>Er is nog geen materieel geselecteerd om te tonen</div>
      <div style={{ fontSize: '16px', marginTop: '19px' }}>
        Voeg materieel toe door het te zoeken in het filterscherm
      </div>
      <Button
        type='button'
        data-testid='ddp-zoeken'
        style={{ marginTop: '45px' }}
        variant='primary'
        onClick={openIndelenPanel}
      >
        Begin met zoeken
      </Button>
    </div>
  );
};
export default PlankNothingToShow;
